import { AbstractDataProviderV2, ActionTypes } from 'components/system';
import { RsAgeGroup } from 'common/customers/services/types/RsAgeGroup';
import { AgeGroupAdd } from 'common/customers/services/types/AgeGroupAdd';
import { RsAgeGroupInfo } from 'common/customers/services/types/RsAgeGroupInfo';
import { AgeGroupUpdate } from 'common/customers/services/types/AgeGroupUpdate';

export class CustomerAgeGroupDataProvider extends AbstractDataProviderV2<RsAgeGroup, RsAgeGroupInfo, AgeGroupAdd, AgeGroupUpdate> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/age-groups');
    }

    public find(sex, birthday): Promise<RsAgeGroupInfo> {
        const url = this.helper.buildUrl(this.apiUrl + '/find', {});
        const params = {
            sex: sex,
            birthday: birthday
        };
        return this.service.getItem(url, params).then((obj: any) => {
            if (obj.id > 0) {
                return obj;
            } else {
                return null;
            }
        });
    }

    public patch(): Promise<null> {
        return Promise.reject('Method is not supported');
    }

    public recalculate(): Promise<void> {
        return this.service.updateRequest(this.apiUrl + '/recalculate/all', 'PUT').then(() => {
            this.notify({ type: ActionTypes.Update, hash: this.apiUrl });
        });
    }
}
